import { Radio } from '@mui/material';
import { BaseRadioProps } from './BaseRadio.types';

/**
 * The base `Radio` control from MUI that we use to wrap off of for our controls. This
 * control creates separation so we can use jest to mock it.
 *
 * @param classes - {@link BaseRadioProps.classes classes} description.
 * @param value - {@link BaseRadioProps.value value} description.
 */
export const BaseRadio = ({
    classes,
    value,
}: BaseRadioProps) => {
    return (
        <Radio
            classes={{
                ...classes,
            }}
            value={value}
        />
    );
};